import { ErrorHandler, Injectable } from '@angular/core';
import { faro, getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { environment } from '../../environments/environment';

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

// Grafana Faro (RUM): sends errors, logs, web vitals and browser traces to a
// Faro collector (Grafana Cloud Frontend Observability or an Alloy
// `faro.receiver`). Disabled when environment.faro.url is empty.
export function initFaro(): void {
  const config = environment.faro;

  if (!config?.url) {
    return;
  }

  initializeFaro({
    url: config.url,
    app: {
      name: config.appName,
      environment: config.environment,
    },
    // Angular reports caught errors through console.error; FaroErrorHandler
    // already pushes them as exceptions, so keep console.error as a plain log.
    consoleInstrumentation: {
      consoleErrorAsLog: true,
    },
    instrumentations: [
      ...getWebInstrumentations(),
      new TracingInstrumentation({
        instrumentationOptions: {
          // Send W3C traceparent to the backend so browser spans join the
          // backend's OpenTelemetry traces in Tempo.
          propagateTraceHeaderCorsUrls: [new RegExp(`^${escapeRegExp(environment.url_be)}`)],
        },
      }),
    ],
  });
}

// Angular catches errors thrown in components and services, so they never
// reach window.onerror; forward them to Faro explicitly.
@Injectable()
export class FaroErrorHandler extends ErrorHandler {
  override handleError(error: unknown): void {
    if (faro.api) {
      faro.api.pushError(error instanceof Error ? error : new Error(String(error)));
    }

    super.handleError(error);
  }
}
